import React from "react";

import { MenuItemsCountsDto, MenuItemsListFilterDto } from "services/menu/restModels";

import { ChipToggle, SearchInput } from "shared/ui";

import { ITEMS_FILTERS } from "features/MenuEditor/constants";

import { Chips, Filters, Search } from "./styles";

interface ItemsToolbarProps {
    query: string;
    onQueryChange: (value: string) => void;
    filter: MenuItemsListFilterDto;
    onFilterChange: (filter: MenuItemsListFilterDto) => void;
    counts: MenuItemsCountsDto;
}

const countFor = (
    filter: MenuItemsListFilterDto,
    counts: MenuItemsCountsDto
): number => {
    switch (filter) {
        case "stopList":
            return counts.stopListCount;
        case "noPhoto":
            return counts.withoutPhotoCount;
        default:
            return counts.allCount;
    }
};

export const ItemsToolbar = ({
    query,
    onQueryChange,
    filter,
    onFilterChange,
    counts,
}: ItemsToolbarProps) => (
    <Filters>
        <Search>
            <SearchInput
                value={query}
                placeholder="Поиск позиции"
                onChange={onQueryChange}
            />
        </Search>

        <Chips>
            {ITEMS_FILTERS.map((option) => (
                <ChipToggle
                    key={option.value}
                    active={filter === option.value}
                    onClick={() => onFilterChange(option.value)}
                >
                    {option.label} · {countFor(option.value, counts)}
                </ChipToggle>
            ))}
        </Chips>
    </Filters>
);
